import React from 'react';
import { Link } from 'react-router-dom';

const WHO_WE_ARE_POINTS = [
  {
    num: '01',
    title: 'Understand Your Business',
    desc: 'We begin by understanding your goals, workflows, and challenges so we can build a solution that addresses real business needs.',
    badgeClass: 'sipl-bg-navy',
    accentColor: '#1a2f6e',
  },
  {
    num: '02',
    title: 'Build for Real Users',
    desc: 'We create simple, intuitive experiences that make everyday tasks easier for your teams and customers.',
    badgeClass: 'sipl-bg-green',
    accentColor: '#4caf50',
  },
  {
    num: '03',
    title: 'Engineer for Growth',
    desc: 'We build secure, maintainable, and scalable solutions designed to perform reliably as your business evolves.',
    badgeClass: 'sipl-bg-teal',
    accentColor: '#0d9488',
  },
];

const WhoWeAreSection = () => {
  return (
    <section className="py-5 sipl-section-transparent" aria-label="Who We Are" style={{ position: 'relative', zIndex: 1 }}>
      <div className="container py-4">
        {/* Centered Section Header */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-12 col-lg-8 sipl-reveal-ttb">
            <span
              className="text-uppercase fw-bold sipl-text-teal tracking-wider small d-block mb-2"
              style={{ letterSpacing: '0.12em' }}
            >
              WHO WE ARE
            </span>
            <h2 className="display-6 fw-bold text-dark mb-3">
              We build technology around your business needs.
            </h2>
            <p
              className="text-muted fs-6 mx-auto mb-3"
              style={{ maxWidth: '680px', lineHeight: '1.8' }}
            >
              We help businesses turn ideas, challenges, and everyday processes into reliable digital solutions. From custom software and business applications to modern web platforms, we design and develop technology that fits the way your team works and grows with your business.
            </p>
            <div className="mt-2">
              <Link
                to="/about"
                className="text-decoration-none fw-semibold sipl-text-navy sipl-arrow-link d-inline-flex align-items-center gap-2"
              >
                Learn More About Us <span>→</span>
              </Link>
            </div>
          </div>
        </div>

        {/* 3 Simple Standard Cards Row */}
        <div className="row g-4 justify-content-center">
          {WHO_WE_ARE_POINTS.map((pt, i) => (
            <div key={pt.title} className="col-12 col-md-6 col-lg-4">
              <div
                className="card h-100 border-0 shadow-sm rounded-4 p-4 sipl-card-hover sipl-reveal-ttb"
                style={{
                  background: '#ffffff',
                  borderTop: `3px solid ${pt.accentColor}`,
                  '--gr-delay': `${200 + i * 150}ms`,
                }}
              >
                <div className="d-flex align-items-center gap-3 mb-3">
                  <span
                    className={`badge rounded-circle ${pt.badgeClass} text-white fw-bold d-flex align-items-center justify-content-center`}
                    style={{ width: '32px', height: '32px', fontSize: '0.85rem' }}
                  >
                    {pt.num}
                  </span>
                  <h3 className="h6 fw-bold text-dark mb-0">{pt.title}</h3>
                </div>
                <p className="text-muted small mb-0" style={{ lineHeight: '1.7' }}>
                  {pt.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreSection;
